import React from "react";
import { SidebarProfileChip } from "../SidebarProfileChip";
import type { SidebarProfileChipProps } from "../SidebarProfileChip";
import { useOptionalTheme } from "../../../providers/ThemeProvider";
import { THEME_MODE_COPY } from "../../themeMode.copy";
import type { ThemePreference } from "../../../design-system/types/theme";
import { useHelpSupportSections } from "../../../hooks/useHelpSupportSections";
import { useProfileMenuActions } from "../../../hooks/useProfileMenuActions";

/** The profile chip wired to the signed-in user. Its data hook runs only where the chip is rendered. */
export const AccountMenuChip: React.FC<Partial<SidebarProfileChipProps>> = (props) => {
  const profileMenu = useProfileMenuActions();
  const sections = useHelpSupportSections();
  const themeContext = useOptionalTheme();
  const segmentedRow = themeContext && {
    label: THEME_MODE_COPY.appearanceLabel,
    options: THEME_MODE_COPY.options,
    value: themeContext.preference,
    onChange: (id: string) => themeContext.setPreference(id as ThemePreference),
  };
  return <SidebarProfileChip {...profileMenu} sections={sections} segmentedRow={segmentedRow || undefined} {...props} />;
};

export default AccountMenuChip;
